import React, { useEffect, useState } from 'react';

const base = 'https://storage.googleapis.com/storage/v1/b/avisamesibaja-images/o/';
const money = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
const checkedDate = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Madrid' });

function recent(p) {
  const age = Date.now() - Date.parse(p.verificado);
  return p.disponible === true && p.moneda === 'EUR' && Number.isFinite(p.actual) && p.actual > 0 && Number.isFinite(age) && age >= -300000 && age <= 86400000;
}

function selectPreview(catalog, telegram, current) {
  const latest = new Map((current?.productos || []).map(p => [p.id, p]));
  const selected = new Map();
  const historical = (catalog?.productos || []).filter(p => latest.has(p.id));
  for (const original of [...historical, ...(telegram?.productos || [])]) {
    const checked = latest.get(original.id);
    if (checked?.disponible === false && Date.parse(current.generado) >= Date.parse(original.verificado)) continue;
    const p = checked && Date.parse(checked.verificado) >= Date.parse(original.verificado) ? { ...original, ...checked } : original;
    if (!/^[A-Z0-9]{10}-ES$/.test(p.id) || !recent(p) || !p.titulo) continue;
    try {
      const url = new URL(p.url);
      const image = new URL(p.imagen);
      if (url.protocol !== 'https:' || !/^(www\.)?amazon\.es$/.test(url.hostname) || image.protocol !== 'https:') continue;
    } catch (_) { continue; }
    const existing = selected.get(p.id);
    if (!existing || Date.parse(p.verificado) >= Date.parse(existing.verificado)) selected.set(p.id, p);
  }
  return [...selected.values()].sort((a, b) => Date.parse(b.publicado || b.verificado) - Date.parse(a.publicado || a.verificado)).slice(0, 3);
}

export default function NewsPreview({ onChoose }) {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    let cancelled = false;
    let controller;
    let loading = false;
    async function refresh() {
      if (loading) return;
      loading = true;
      controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const results = await Promise.allSettled(['precios.json', 'novedades-telegram.json', 'precios-actuales.json'].map(async file => {
          const response = await fetch(base + encodeURIComponent('datos/' + file) + '?alt=media', { cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Public prices unavailable');
          const data = await response.json();
          if (!Array.isArray(data.productos)) throw new Error('Invalid public catalog');
          return data;
        }));
        if (!cancelled) setProducts(selectPreview(...results.map(r => r.status === 'fulfilled' ? r.value : null)));
      } finally { clearTimeout(timeout); loading = false; }
    }
    refresh();
    const refreshTimer = setInterval(refresh, 300000);
    const expiryTimer = setInterval(() => setProducts(previous => previous.filter(recent)), 60000);
    return () => { cancelled = true; controller?.abort(); clearInterval(refreshTimer); clearInterval(expiryTimer); };
  }, []);

  return (
    <section className="start-news" aria-labelledby="start-news-title">
      <div className="start-news-heading">
        <div><span className="start-eyebrow">IDEAS PARA TU LISTA</span><h2 id="start-news-title">¿Todavía no tienes un producto en mente?</h2><p>Elige uno de Novedades y crea tu alerta desde el formulario.</p></div>
        <a href="/novedades/">Ver todas las novedades <span aria-hidden="true">→</span></a>
      </div>
      {products.length > 0 && <div className="start-news-grid">{products.map(p => (
        <article className="start-news-card" key={p.id}>
          <img src={p.imagen} alt={p.titulo} loading="lazy" width="320" height="160" />
          <h3>{p.titulo}</h3>
          <span className="start-news-price-label">Último precio comprobado</span>
          <strong className="start-news-price">{money.format(p.actual)}</strong>
          <p className="start-news-checked">{checkedDate.format(new Date(p.verificado))} · Madrid</p>
          <button type="button" className="start-secondary" onClick={() => onChoose(p.url)}>Seguir este producto <span aria-hidden="true">↑</span></button>
        </article>
      ))}</div>}
      <aside className="start-telegram" aria-labelledby="home-telegram-title">
        <div><span className="start-eyebrow">NUESTRA SELECCIÓN EN TELEGRAM</span><h3 id="home-telegram-title">Ideas para tu próxima compra, también en tu móvil</h3><p>Recibe productos seleccionados y precios comprobados en nuestro canal gratuito. Para vigilar un producto concreto, crea tu alerta personal por email.</p></div>
        <a className="start-secondary" href="https://t.me/avisamesibaja" target="_blank" rel="noopener noreferrer" onClick={() => {
          try { if (localStorage.getItem('cookiesAccepted') === 'true' && window.gtag) window.gtag('event', 'telegram_click', { placement: 'home_novedades', link_url: 'https://t.me/avisamesibaja' }); } catch (_) { /* Optional analytics. */ }
        }}>Ver el canal de Telegram <span aria-hidden="true">↗</span></a>
      </aside>
    </section>
  );
}
